import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function AuthCallback() {
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error')
  const errorDescription = searchParams.get('error_description')
  const adminConsent = searchParams.get('admin_consent')

  useEffect(() => {
    // Auto-close this window after a short delay
    const timer = setTimeout(() => {
      window.close()
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white rounded-lg shadow p-6 text-center">
          <svg className="mx-auto h-12 w-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <h2 className="mt-4 text-lg font-semibold text-gray-900">Authorization Failed</h2>
          <p className="mt-2 text-sm text-gray-600">{errorDescription || error}</p>
          <p className="mt-4 text-xs text-gray-400">This window will close automatically...</p>
          <button
            onClick={() => window.close()}
            className="mt-4 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            Close Window
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-6 text-center">
        <svg className="mx-auto h-12 w-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <h2 className="mt-4 text-lg font-semibold text-gray-900">
          {adminConsent === 'True' ? 'App Authorized Successfully' : 'Authorization Complete'}
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          The Partner License Portal has been authorized for this customer tenant.
        </p>
        <p className="mt-4 text-xs text-gray-400">This window will close automatically...</p>
        <button
          onClick={() => window.close()}
          className="mt-4 px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700"
        >
          Close Window
        </button>
      </div>
    </div>
  )
}
